// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-f087f3ca","scoped":true,"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=1!./FrontEnd/modulos/central-mensagens/componentes/CentralMensagens.vue
// module id = 1277
// module chunks = 0